import React from 'react';
import './WhatsAppFloatingButton.css';

const WhatsAppFloatingButton = () => {
  const phoneNumber = '+919176122210';
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  return (
    <a
      href={whatsappUrl}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <g>
          <circle cx="24" cy="24" r="24" fill="#25D366" />
          <path d="M24 12c-6.627 0-12 5.373-12 12 0 2.122.555 4.193 1.609 6.013L12 36l6.13-1.604A11.96 11.96 0 0024 36c6.627 0 12-5.373 12-12s-5.373-12-12-12zm0 22.222c-1.813 0-3.588-.497-5.13-1.438l-.366-.217-3.64.953.973-3.548-.238-.374A9.77 9.77 0 0114.222 24c0-5.384 4.394-9.778 9.778-9.778S33.778 18.616 33.778 24 29.384 33.778 24 33.778zm5.222-7.222c-.287-.144-1.698-.838-1.962-.934-.263-.096-.454-.144-.646.144-.192.287-.74.934-.908 1.127-.168.192-.336.216-.623.072-.287-.144-1.213-.447-2.312-1.425-.855-.761-1.432-1.7-1.602-1.987-.168-.287-.018-.443.126-.587.13-.13.287-.336.431-.504.144-.168.192-.287.287-.479.096-.192.048-.359-.024-.504-.072-.144-.646-1.56-.885-2.137-.233-.561-.47-.484-.646-.492l-.55-.009c-.192 0-.504.072-.768.359-.263.287-1.01.987-1.01 2.404 0 1.417 1.036 2.788 1.181 2.983.144.192 2.04 3.116 5.03 4.244.704.242 1.252.387 1.679.495.705.18 1.348.155 1.855.094.566-.067 1.698-.693 1.94-1.363.24-.67.24-1.244.168-1.363-.072-.119-.263-.192-.55-.336z" fill="#fff"/>
        </g>
      </svg>
    </a>
  );
};

export default WhatsAppFloatingButton;
